import React from 'react';
import { useLocation } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const SiteSchema = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const whatsappNumber = (process.env.REACT_APP_WHATSAPP_NUMBER || '34600000000').replace(
    /[^0-9]/g,
    ''
  );

  // JSON-LD Structured Data for Google & AI Search Engines (ChatGPT, Perplexity, Gemini)
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': ['ProfessionalService', 'Dietitian', 'HealthAndBeautyBusiness'],
        '@id': 'https://www.todoenbalance.com/#organization',
        name: 'TODOenBALANCE',
        url: 'https://www.todoenbalance.com',
        logo: 'https://www.todoenbalance.com/logo512.png',
        image: 'https://www.todoenbalance.com/logo512.png',
        description:
          'Online nutrition consultancy and downloadable evidence-based meal plans by nutritionist Paola Michelle.',
        email: 'info@todoenbalance.com',
        priceRange: '€€',
        areaServed: 'Worldwide',
        availableLanguage: ['es', 'en', 'it'],
        founder: {
          '@type': 'Person',
          '@id': 'https://www.todoenbalance.com/#paola',
          name: 'Paola Michelle',
          jobTitle: 'Nutritionist & Wellness Consultant',
          email: 'paola@todoenbalance.com',
          knowsLanguage: ['es', 'en', 'it'],
        },
        contactPoint: [
          {
            '@type': 'ContactPoint',
            contactType: 'customer support',
            email: 'info@todoenbalance.com',
            availableLanguage: ['es', 'en', 'it'],
          },
          {
            '@type': 'ContactPoint',
            contactType: 'nutrition consultations',
            email: 'paola@todoenbalance.com',
            availableLanguage: ['es', 'en', 'it'],
          },
        ],
      },
      {
        '@type': 'WebSite',
        '@id': 'https://www.todoenbalance.com/#website',
        url: 'https://www.todoenbalance.com',
        name: 'TODOenBALANCE',
        inLanguage: (i18n.language || 'en').split('-')[0],
        publisher: { '@id': 'https://www.todoenbalance.com/#organization' },
      },
    ],
  };

  const isBookingOrAdmin =
    location.pathname.startsWith('/admin') || location.pathname.startsWith('/booking');

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      {!isBookingOrAdmin && (
        <a
          href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
            'Hola Paola! I would like more information about TODOenBALANCE.'
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
          className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white font-bold text-sm px-4 py-3.5 rounded-full shadow-xl hover:shadow-2xl transition-all hover:-translate-y-0.5"
        >
          <MessageCircle className="w-5 h-5" />
          <span className="hidden sm:inline">WhatsApp</span>
        </a>
      )}
    </>
  );
};

export default SiteSchema;
